var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.step === 1
    ? _c(
        "info",
        _vm._b(
          {
            attrs: { id: _vm.id, bindMap: _vm.bindMap },
            on: {
              save: _vm.onSave,
              next: function ($event) {
                return _vm.$emit("next")
              },
            },
          },
          "info",
          _vm.$attrs,
          false
        )
      )
    : _vm.step === 2
    ? _c(
        "relations",
        _vm._b(
          {
            attrs: {
              id: _vm.id,
              getUsers: _vm.getUsers,
              isEdit: _vm.isEdit,
              dataPermissionCode: _vm.dataPermissionCode,
              evaluatorDataPermission: _vm.evaluatorDataPermission,
              functionCode: _vm.functionCode,
            },
            on: {
              next: function ($event) {
                return _vm.$emit("next")
              },
              prev: _vm.onPrev,
            },
          },
          "relations",
          _vm.$attrs,
          false
        )
      )
    : _c(
        "publish",
        _vm._b(
          {
            attrs: {
              "can-publish": _vm.canPublish,
              "can-save": _vm.canSave,
              id: _vm.id,
              "no-timing": "",
            },
            on: {
              save: function ($event) {
                return _vm.$emit("save")
              },
              prev: function ($event) {
                return _vm.$emit("prev")
              },
            },
          },
          "publish",
          _vm.$attrs,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }